(function () {
  'use strict';

  /* ── Money formatting ── */

  function formatMoney(priceStr, format) {
    const amount = parseFloat(priceStr).toFixed(2);
    const amountNoDecimals = String(Math.round(parseFloat(priceStr)));
    const amountComma = amount.replace('.', ',');
    return (format || '{{amount}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ── Search query ── */

  function getSearchQuery() {
    var input = document.querySelector('[data-collection-product-search]');
    return input ? input.value.trim().toLowerCase() : '';
  }

  function getSearchMode() {
    var config = window.__collectionSearch || {};
    return config.mode || 'ring';
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase();
  }

  function stripHtml(value) {
    var div = document.createElement('div');
    div.innerHTML = value || '';
    return div.textContent || div.innerText || '';
  }

  function textContainsAny(text, keywords) {
    return keywords.some(function (keyword) {
      return text.indexOf(keyword) !== -1;
    });
  }

  function getScentStyles(description, tags, productType) {
    var scentText = normalizeText([description, tags, productType].join(' '));
    var styles = [];
    var fruityKeywords = [
      'fruit', 'fruity', 'apple', 'apricot', 'berry', 'berries', 'blackberry',
      'blackcurrant', 'blueberry', 'cherry', 'citrus', 'coconut', 'currant',
      'fig', 'grape', 'grapefruit', 'guava', 'lemon', 'lime', 'lychee',
      'mandarin', 'mango', 'melon', 'nectarine', 'orange', 'papaya',
      'passionfruit', 'peach', 'pear', 'pineapple', 'plum', 'pomegranate',
      'raspberry', 'strawberry', 'tangerine', 'watermelon'
    ];
    var floralKeywords = [
      'floral', 'flower', 'blossom', 'freesia', 'gardenia', 'geranium',
      'hibiscus', 'honeysuckle', 'iris', 'jasmine', 'lavender', 'lily',
      'magnolia', 'marigold', 'neroli', 'orange blossom', 'orchid', 'peony',
      'rose', 'tuberose', 'violet', 'white flowers', 'ylang'
    ];

    if (textContainsAny(scentText, fruityKeywords)) styles.push('fruity');
    if (textContainsAny(scentText, floralKeywords)) styles.push('floral');

    return styles.join(' ');
  }

  /* ── Exact size matching (ring collections) ── */

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getSizeTerms(query) {
    var terms = [];
    var pattern = /(^|[^0-9a-z.])(\d+(?:\.\d+)?)(?![0-9a-z.])/gi;
    var match;

    while ((match = pattern.exec(query.toLowerCase())) !== null) {
      terms.push(match[2]);
    }

    return terms;
  }

  function isSizeTerm(term) {
    return /^\d+(?:\.\d+)?$/.test(term);
  }

  // A size must be a complete number: searching for 5 must not match 5.5.
  function includesExactSize(text, size) {
    var pattern = new RegExp('(^|[^0-9.])' + escapeRegExp(size) + '(?![0-9.])');
    return pattern.test(text);
  }

  function matchesSearchTerms(text, terms) {
    var lowerText = text.toLowerCase();
    return terms.every(function (term) {
      return isSizeTerm(term) ? includesExactSize(lowerText, term) : lowerText.indexOf(term) !== -1;
    });
  }

  // Sets can have more than one size option (one per ring in the bundle).
  // A variant only counts as a match for the searched size if EVERY size
  // option on it equals that size — otherwise a variant where just one
  // ring's size happens to match (but the other ring is a different size)
  // would be treated as "size 8" when only one of the two rings actually is.
  function getMatchingSizeVariant(product, query) {
    var sizeTerms = getSizeTerms(query);
    if (sizeTerms.length === 0 || !product.sizeVariants) return null;

    var variants = product.sizeVariants.filter(function (entry) {
      var values = entry.sizeValues || [entry.label];
      return values.every(function (value) {
        var valueText = String(value).toLowerCase();
        return sizeTerms.every(function (term) { return includesExactSize(valueText, term); });
      });
    });

    return variants.find(function (entry) { return entry.available; }) || variants[0] || null;
  }

  // Sizes with an in-stock variant in the exact searched size sort ahead of
  // out-of-stock ones, so a customer searching a size sees what they can
  // actually buy first.
  function sortSearchMatches(products, query) {
    return products.sort(function (first, second) {
      var firstVariant = getMatchingSizeVariant(first, query);
      var secondVariant = getMatchingSizeVariant(second, query);
      var firstUnavailable = firstVariant ? !firstVariant.available : !first.available;
      var secondUnavailable = secondVariant ? !secondVariant.available : !second.available;
      return Number(firstUnavailable) - Number(secondUnavailable);
    });
  }

  /* ── Dynamic search result cards ── */

  var injectedCards = [];
  var activeChipTerm = '';

  function scrollToCollectionResults() {
    var target = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (!target) return;

    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        var header = document.querySelector('.section-header');
        var headerOffset = header ? header.getBoundingClientRect().height : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth'
        });
      }, 50);
    });
  }

  function scrollToCollectionSearch() {
    var searchWrap = document.querySelector('.collection-product-search');
    var searchInput = document.querySelector('[data-collection-product-search]');
    var target = searchWrap || searchInput;
    if (!target) return;

    var header = document.querySelector('.section-header');
    var headerOffset = header ? header.getBoundingClientRect().height : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });

    window.setTimeout(function () {
      if (searchInput) {
        searchInput.focus({ preventScroll: true });
      }
    }, 450);
  }

  function initBackToSearchButton(searchInput) {
    var searchWrap = document.querySelector('.collection-product-search');
    if (!searchInput || !searchWrap || document.querySelector('[data-collection-back-to-search]')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-back-to-search';
    button.setAttribute('data-collection-back-to-search', '');
    button.setAttribute('aria-label', 'Back to collection search');
    button.innerHTML = '<span aria-hidden="true">&uarr;</span>';
    document.body.appendChild(button);

    function setVisible(isVisible) {
      button.classList.toggle('collection-back-to-search--visible', isVisible);
      document.body.classList.toggle('collection-back-to-search-visible', isVisible);
    }

    button.addEventListener('click', scrollToCollectionSearch);

    // Show once the search box is hidden behind the sticky header, not once
    // scrollY passes some fixed or pre-scroll value: the header is sticky,
    // so scrollToCollectionResults() (fired on Enter) only scrolls enough to
    // tuck the search box behind it, which barely moves scrollY on a tall
    // header. Measuring the header's actual rendered height (same approach
    // scrollToCollectionResults/scrollToCollectionSearch already use) keeps
    // this correct regardless of header height or breakpoint.
    function getHeaderOffset() {
      var header = document.querySelector('.section-header');
      return header ? header.getBoundingClientRect().height : 0;
    }

    var ticking = false;
    function checkVisibility() {
      var rect = searchWrap.getBoundingClientRect();
      setVisible(rect.bottom <= getHeaderOffset());
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        checkVisibility();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    checkVisibility();
  }

  function clearInjectedCards() {
    injectedCards.forEach(function (el) { el.remove(); });
    injectedCards = [];
  }

  function getVariantLabel(variant) {
    var label = variant && variant.title ? variant.title : '';
    if (!label || label === 'Default Title') {
      return 'Default';
    }
    return label;
  }

  function getAvailableVariants(product) {
    return (product.variants || []).filter(function (variant) {
      return variant.available !== false;
    });
  }

  function getPreferredVariant(product, query) {
    var variants = getAvailableVariants(product);
    if (variants.length === 0) return null;

    var terms = String(query || '').toLowerCase().split(/\s+/).filter(Boolean);
    var matchedVariant = variants.find(function (variant) {
      var label = getVariantLabel(variant).toLowerCase();
      return terms.length > 0 && terms.some(function (term) {
        return label === term || label.indexOf(term) !== -1;
      });
    });

    return matchedVariant || variants[0];
  }

  function showAddToCartMessage(card, message, isError) {
    var messageEl = card.querySelector('[data-collection-search-cart-message]');
    if (!messageEl) return;

    messageEl.textContent = message || '';
    messageEl.classList.toggle('collection-search-card__message--error', Boolean(isError));
    messageEl.hidden = !message;
  }

  function addVariantToCart(variantId, button, card) {
    if (!variantId || !button || !card) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(button);
      }
    }

    var originalLabel = button.textContent;

    button.disabled = true;
    button.classList.add('collection-search-card__cta--loading');
    button.textContent = 'Adding…';
    showAddToCartMessage(card, '', false);

    var config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/json' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    function refreshCartIconBubble() {
      return fetch(((window.routes && routes.cart_url) || '/cart') + '.js')
        .then(function (cartResponse) { return cartResponse.json(); })
        .then(function (cartState) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && typeof cartState.item_count === 'number') {
            bubble.innerHTML = '<div class="cart-count-bubble"><span aria-hidden="true">' + cartState.item_count + '</span><span class="visually-hidden">' + cartState.item_count + ' items</span></div>';
          }
          return cartState;
        });
    }

    fetch((window.routes && routes.cart_add_url) || '/cart/add.js', config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          showAddToCartMessage(card, response.description || 'Unable to add this item.', true);
          return;
        }

        var rendered = false;
        if (cart && typeof cart.renderContents === 'function' && response.sections) {
          try {
            cart.renderContents(response);
            rendered = true;
          } catch (renderError) {
            // Section HTML failed to parse/apply; fall through to opening
            // the drawer manually below so the add isn't silently invisible.
            console.error('Cart drawer render failed', renderError);
          }
        }

        // renderContents already refreshes the cart icon section. Only fall
        // back to a manual bubble refresh + drawer open if it did not run.
        if (!rendered) {
          refreshCartIconBubble().then(function () {
            if (cart && typeof cart.open === 'function') cart.open(button);
          });
        }

        showAddToCartMessage(card, 'Added to cart', false);
        button.classList.add('collection-search-card__cta--added');
        button.textContent = 'Added to cart';

        window.setTimeout(function () {
          button.classList.remove('collection-search-card__cta--added');
          button.textContent = originalLabel;
          showAddToCartMessage(card, '', false);
        }, 1800);
      })
      .catch(function () {
        showAddToCartMessage(card, 'Unable to add this item.', true);
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('collection-search-card__cta--loading');
        if (!button.classList.contains('collection-search-card__cta--added')) {
          button.textContent = originalLabel;
        }
      });
  }

  function getWhatsAppInquiryUrl(product, query) {
    var message = 'Hi, I am interested in this product';
    var sizeTerms = getSearchMode() === 'ring' ? getSizeTerms(query) : [];
    if (sizeTerms.length > 0) {
      message += ' in size ' + sizeTerms.join(', ');
    }
    message += ': ' + product.title;
    var productUrl = window.location.origin + product.url;
    return 'https://wa.me/18683337401?text=' + encodeURIComponent(message) + '%0A%0A' + encodeURIComponent(productUrl);
  }

  // Top-right tag naming the exact size the customer searched for, shown on
  // every card regardless of stock status (the bottom-left badge already
  // covers in-stock/preorder — this one is purely "here's the size you
  // searched", so shoppers scanning a grid of mixed sizes/colors can tell
  // at a glance which card matches their search). Colored the same as the
  // in-stock/preorder badge so the two tags agree on availability at a glance.
  function buildSizeTag(query, sizeMatchedVariant) {
    var sizeTerms = getSearchMode() === 'ring' ? getSizeTerms(query) : [];
    if (sizeTerms.length === 0) return null;

    var isAvailable = sizeMatchedVariant ? Boolean(sizeMatchedVariant.available) : true;
    var tag = document.createElement('p');
    tag.className = 'collection-search-card__size-tag collection-search-card__size-tag--'
      + (isAvailable ? 'in-stock' : 'preorder');
    tag.textContent = 'Size ' + sizeTerms.join(', ');
    return tag;
  }

  function buildAvailabilityBadge(product, sizeMatchedVariant) {
    // Only meaningful once a size has actually been searched; a plain
    // title search has no single size to report availability for.
    if (!sizeMatchedVariant) return null;

    var badge = document.createElement('p');
    var isAvailable = Boolean(sizeMatchedVariant.available);
    badge.className = 'collection-search-card__availability collection-search-card__availability--'
      + (isAvailable ? 'in-stock' : 'preorder');
    badge.textContent = isAvailable ? 'In stock' : 'Preorder available';
    return badge;
  }

  // Bucketed into the ring metals (black, gold, silver, etc.) and deduped
  // by resolved swatch color, so "Silver" and "White Gold" don't produce
  // two near-identical circles. A name that matches no bucket falls back
  // to a neutral swatch rather than being dropped, since a missing circle
  // reads as that color being out of stock in the searched size.
  function colorToSwatchColor(name) {
    var key = String(name || '').toLowerCase().trim();
    if (!key) return null;
    if (key.indexOf('black') !== -1 || key.indexOf('gunmetal') !== -1 || key.indexOf('onyx') !== -1) return '#1c1c1c';
    if (key.indexOf('space gray') !== -1 || key.indexOf('space grey') !== -1) return '#B8B8B8';
    if (key.indexOf('rose') !== -1) return '#B76E79';
    if (key.indexOf('white gold') !== -1 || key.indexOf('silver') !== -1
      || key.indexOf('platinum') !== -1 || key.indexOf('steel') !== -1
      || key.indexOf('chrome') !== -1) return '#C0C0C0';
    if (key.indexOf('gold') !== -1) return '#D4AF37';
    if (key.indexOf('white') !== -1 || key.indexOf('ivory') !== -1 || key.indexOf('pearl') !== -1) return '#F5F5F0';
    if (key.indexOf('gray') !== -1 || key.indexOf('grey') !== -1) return '#A8A8A8';
    if (window.CSS && CSS.supports && CSS.supports('color', key)) return key;
    return '#9AA0A6';
  }

  // Only colors with an in-stock variant in the exact searched size, so a
  // product with one available color in that size shows one swatch, not all.
  function getAvailableColorsForQuery(product, query) {
    var sizeTerms = getSizeTerms(query);
    if (sizeTerms.length === 0 || !product.sizeVariants) return [];

    var seen = {};
    var colors = [];
    product.sizeVariants.forEach(function (entry) {
      if (!entry.available || !entry.color) return;
      var values = entry.sizeValues || [entry.label];
      var matchesSize = values.every(function (value) {
        var valueText = String(value).toLowerCase();
        return sizeTerms.every(function (term) { return includesExactSize(valueText, term); });
      });
      if (!matchesSize) return;
      var swatchColor = colorToSwatchColor(entry.color);
      if (swatchColor && !seen[swatchColor]) {
        seen[swatchColor] = true;
        colors.push({ name: entry.color, swatchColor: swatchColor });
      }
    });

    return colors;
  }

  function buildColorSwatches(colors) {
    if (!colors || colors.length === 0) return null;
    var wrap = document.createElement('div');
    wrap.className = 'search-color-swatches';
    colors.forEach(function (color) {
      var span = document.createElement('span');
      span.className = 'search-color-swatch';
      span.style.backgroundColor = color.swatchColor;
      span.title = color.name;
      span.setAttribute('aria-label', color.name);
      wrap.appendChild(span);
    });
    return wrap;
  }

  function buildDynamicCard(product, moneyFormat, query) {
    var li = document.createElement('li');
    li.className = 'grid__item collection-search-injected';

    var card = document.createElement('div');
    card.className = 'collection-search-card';
    card.setAttribute('data-product-title', product.title);

    var mode = getSearchMode();
    var sizeMatchedVariant = mode === 'ring' ? getMatchingSizeVariant(product, query) : null;

    // Without a variant param, the product page falls back to Shopify's own
    // default variant selection, which can land on a different size than
    // the one that was just confirmed in stock here (e.g. a half size) —
    // so link straight to the exact size/variant this card matched.
    var linkVariantId = sizeMatchedVariant ? sizeMatchedVariant.id : null;
    if (!linkVariantId) {
      var textMatchedVariant = getPreferredVariant(product, query);
      if (textMatchedVariant) linkVariantId = textMatchedVariant.id;
    }
    var productUrl = linkVariantId ? (product.url + '?variant=' + linkVariantId) : product.url;

    if (product.cardImage) {
      var imageLink = document.createElement('a');
      imageLink.href = productUrl;
      imageLink.className = 'collection-search-card__image-link';
      imageLink.setAttribute('aria-label', product.title);

      var imgWrap = document.createElement('div');
      imgWrap.className = 'collection-search-card__image-wrap';
      var img = document.createElement('img');
      img.src = product.cardImage;
      img.alt = product.title;
      img.loading = 'lazy';
      img.className = 'collection-search-card__image';
      imgWrap.appendChild(img);

      var availabilityBadge = buildAvailabilityBadge(product, sizeMatchedVariant);
      var colorSwatches = buildColorSwatches(getAvailableColorsForQuery(product, query));
      if (availabilityBadge || colorSwatches) {
        var availabilityRow = document.createElement('div');
        availabilityRow.className = 'collection-search-card__availability-row';
        if (availabilityBadge) availabilityRow.appendChild(availabilityBadge);
        if (colorSwatches) availabilityRow.appendChild(colorSwatches);
        imgWrap.appendChild(availabilityRow);
      }

      var sizeTag = buildSizeTag(query, sizeMatchedVariant);
      if (sizeTag) imgWrap.appendChild(sizeTag);

      imageLink.appendChild(imgWrap);
      card.appendChild(imageLink);
    }

    var info = document.createElement('div');
    info.className = 'collection-search-card__info';

    // Title + price live in their own non-flex group. -webkit-line-clamp
    // doesn't compute height correctly when its element is a direct flex
    // column child, which caused the price to overlap a wrapped title;
    // grouping them keeps that clamp math outside the flex layout while
    // .collection-search-card__actions still gets pushed to the bottom.
    var textGroup = document.createElement('div');
    textGroup.className = 'collection-search-card__text';

    var titleLink = document.createElement('a');
    titleLink.href = productUrl;
    titleLink.className = 'collection-search-card__title-link';
    var title = document.createElement('p');
    title.className = 'collection-search-card__title';
    title.textContent = product.title;
    titleLink.appendChild(title);
    textGroup.appendChild(titleLink);

    if (product.price) {
      var price = document.createElement('p');
      price.className = 'collection-search-card__price';
      price.textContent = formatMoney(product.price, moneyFormat);
      textGroup.appendChild(price);
    }

    info.appendChild(textGroup);

    var availableVariants = getAvailableVariants(product);
    var preferredVariant = getPreferredVariant(product, query);

    // A size was searched: only offer add-to-cart for that exact size, and
    // only when it's in stock. Falling back to a different size's variant
    // would add the wrong ring size to the customer's cart.
    if (sizeMatchedVariant) {
      preferredVariant = sizeMatchedVariant.available
        ? { id: sizeMatchedVariant.id, title: sizeMatchedVariant.label }
        : null;
    }

    var actions = document.createElement('div');
    actions.className = 'collection-search-card__actions';

    if (availableVariants.length > 0 && preferredVariant) {
      var selectedVariantId = String(preferredVariant.id);

      var addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'collection-search-card__cta collection-search-card__cta--cart';
      addButton.textContent = 'Add to cart';
      addButton.addEventListener('click', function () {
        addVariantToCart(selectedVariantId, addButton, card);
      });
      actions.appendChild(addButton);
    } else {
      // No in-stock variant matches the search (e.g. the exact size
      // requested is unavailable): offer WhatsApp instead of a dead add-to-
      // cart button, mirroring the product page's sold-out fallback.
      var whatsappLink = document.createElement('a');
      whatsappLink.className = 'collection-search-card__cta collection-search-card__cta--whatsapp';
      whatsappLink.href = getWhatsAppInquiryUrl(product, query);
      whatsappLink.target = '_blank';
      whatsappLink.rel = 'noopener';
      whatsappLink.textContent = 'Message On Whatsapp';
      actions.appendChild(whatsappLink);
    }

    info.appendChild(actions);

    card.appendChild(info);
    li.appendChild(card);
    return li;
  }

  function injectSearchResults(query, chipMode) {
    clearInjectedCards();

    var grid = document.getElementById('product-grid');
    if (!grid || !allCollectionProducts || !query) return;

    var config = window.__collectionSearch || {};
    var moneyFormat = config.moneyFormat || '{{amount}}';
    var lowerQuery = query.toLowerCase();
    var terms = lowerQuery.split(/\s+/).filter(Boolean);
    var mode = getSearchMode();

    var matches;
    if (mode === 'perfume') {
      matches = allCollectionProducts.filter(function (p) {
        if (chipMode) {
          var haystack = [p.title, p.productType, p.tags, p.description, p.scentStyles].join(' ').toLowerCase();
          return terms.some(function (t) { return haystack.indexOf(t) !== -1; });
        }
        var searchHaystack = [p.title, p.description, p.scentStyles].join(' ').toLowerCase();
        return terms.every(function (t) { return searchHaystack.indexOf(t) !== -1; });
      });
    } else {
      matches = sortSearchMatches(allCollectionProducts.filter(function (p) {
        var matchingSizeVariant = getMatchingSizeVariant(p, query);
        var searchHasSize = getSizeTerms(query).length > 0;

        // A numeric query must match an exact value in the product's size
        // option. This prevents "5" from matching "Size 15" or "Size 5.5".
        if (searchHasSize && !matchingSizeVariant) return false;
        if (!p.available && !matchingSizeVariant) return false;
        if (chipMode) {
          var ringHaystack = [p.title, p.productType, p.tags, p.sizes].join(' ').toLowerCase();
          return terms.some(function (t) {
            return isSizeTerm(t) ? includesExactSize(ringHaystack, t) : ringHaystack.indexOf(t) !== -1;
          });
        }
        var ringSearchHaystack = [p.title, p.sizes].join(' ').toLowerCase();
        return matchesSearchTerms(ringSearchHaystack, terms);
      }), query);
    }

    matches.forEach(function (product) {
      var card = buildDynamicCard(product, moneyFormat, query);
      grid.appendChild(card);
      injectedCards.push(card);
    });
  }

  /* ── Active query reminder ── */

  // Keeps a persistent "Showing results for size 8" style note visible near
  // the search field, so a customer who has scrolled down through results
  // doesn't lose track of what size/term they searched for.
  function updateActiveQueryIndicator(query) {
    var indicator = document.querySelector('[data-collection-search-active-query]');
    if (!indicator) return;

    if (!query) {
      indicator.hidden = true;
      indicator.innerHTML = '';
      return;
    }

    var mode = getSearchMode();
    var sizeTerms = mode === 'ring' ? getSizeTerms(query) : [];
    var label;
    if (sizeTerms.length > 0) {
      label = 'Showing results for size <strong>' + sizeTerms.join(', ') + '</strong>';
    } else {
      var escapedQuery = query.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      label = 'Showing results for <strong>&ldquo;' + escapedQuery + '&rdquo;</strong>';
    }

    indicator.innerHTML = label;
    indicator.hidden = false;
  }

  /* ── Search filter applied to grid ── */

  function applySearchFilter(options) {
    var shouldScrollToResults = options && options.scrollToResults;
    var query = getSearchQuery();
    var searchActive = query.length > 0;

    var gridItems = document.querySelectorAll('#product-grid .grid__item:not(.collection-search-injected)');
    var pagination = document.querySelector('.pagination-wrapper, .pagination');

    clearInjectedCards();
    updateActiveQueryIndicator(query);

    if (searchActive) {
      var chipMode = activeChipTerm !== '' && query.toLowerCase().indexOf(activeChipTerm.toLowerCase()) !== -1;
      gridItems.forEach(function (item) { item.style.display = 'none'; });
      var config = window.__collectionSearch || {};
      if (allCollectionProducts === null && config.handle) {
        fetchCollectionProducts(config.handle).then(function () {
          if (getSearchQuery() === query) {
            injectSearchResults(query, chipMode);
            if (shouldScrollToResults) {
              scrollToCollectionResults();
            }
          }
        });
      } else {
        injectSearchResults(query, chipMode);
        if (shouldScrollToResults) {
          scrollToCollectionResults();
        }
      }
    } else {
      gridItems.forEach(function (item) { item.style.display = ''; });
    }

    if (pagination) {
      pagination.style.display = searchActive ? 'none' : '';
    }
  }

  /* ── Collection product fetch ── */

  var allCollectionProducts = null;
  var collectionProductsRequest = null;

  function fetchCollectionProducts(handle) {
    if (allCollectionProducts !== null) {
      return Promise.resolve(allCollectionProducts);
    }

    if (collectionProductsRequest !== null) {
      return collectionProductsRequest;
    }

    collectionProductsRequest = fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        allCollectionProducts = (data.products || []).map(function (p) {
          var thumb = '';
          var cardImage = '';
          if (p.images && p.images.length > 0) {
            thumb = p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_150x$1$2');
            cardImage = p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_533x$1$2');
          }
          var tagsStr = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
          var description = stripHtml(p.body_html || '');
          var scentStyles = getScentStyles(description, tagsStr, p.product_type || '');
          var variants = (p.variants || []).map(function (variant) {
            return {
              id: variant.id,
              title: variant.title || '',
              available: variant.available,
              price: variant.price || ''
            };
          });
          // Sets can have more than one size option — one per ring in the
          // bundle. Every size option's value is captured per variant
          // (sizeValues) so a search can require ALL of them to match the
          // searched size, not just the first one.
          var sizeOptions = (p.options || []).filter(function (option) {
            return /size/i.test(option.name || '');
          });
          var colorOption = (p.options || []).find(function (option) {
            return /colou?r/i.test(option.name || '');
          });
          var colorPosition = colorOption ? (colorOption.position || null) : null;
          var sizeVariants = sizeOptions.length > 0 ? (p.variants || []).map(function (variant) {
            var sizeValues = sizeOptions.map(function (option) {
              return variant['option' + (option.position || 1)];
            });
            if (sizeValues.some(function (value) { return !value; })) return null;
            var label = sizeOptions.map(function (option, i) {
              return option.name + ' ' + sizeValues[i];
            }).join(', ');
            return {
              id: variant.id,
              label: label,
              sizeValues: sizeValues,
              available: !!variant.available,
              color: colorPosition ? variant['option' + colorPosition] : null
            };
          }).filter(Boolean) : [];
          var sizes = sizeVariants.map(function (entry) { return entry.label; });
          return {
            title: p.title,
            productType: p.product_type || '',
            tags: tagsStr,
            description: description,
            scentStyles: scentStyles,
            sizes: sizes.join(' '),
            sizeVariants: sizeVariants,
            available: variants.some(function (variant) { return variant.available; }),
            url: '/products/' + p.handle,
            image: thumb,
            cardImage: cardImage,
            price: p.variants && p.variants[0] ? p.variants[0].price : '',
            variants: variants
          };
        });
        return allCollectionProducts;
      })
      .catch(function () {
        allCollectionProducts = [];
        return [];
      });

    return collectionProductsRequest;
  }

  /* ── Init ── */

  function init() {
    var config = window.__collectionSearch || {};
    if (config.handle) {
      fetchCollectionProducts(config.handle);
    }

    var searchInput = document.querySelector('[data-collection-product-search]');
    var clearBtn = document.querySelector('[data-collection-search-clear]');

    if (searchInput) {
      initBackToSearchButton(searchInput);

      var debounceTimer;

      searchInput.addEventListener('input', function (event) {
        event.stopPropagation();
        var query = searchInput.value.trim();

        if (clearBtn) {
          clearBtn.classList.toggle('collection-product-search__clear--visible', query.length > 0);
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          applySearchFilter();
        }, 250);
      });

      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          clearTimeout(debounceTimer);
          applySearchFilter({ scrollToResults: true });
          searchInput.blur();
        } else if (event.key === 'Escape') {
          searchInput.blur();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        activeChipTerm = '';
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
        }
        clearBtn.classList.remove('collection-product-search__clear--visible');
        applySearchFilter();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
